import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { X_CHANNEL } from '../constants/x-channel.constant';

@Injectable()
export class LoginInterceptor implements HttpInterceptor {
  private loginUrl = environment.loginCidadao.tokenEndpoint;

  public intercept(request: HttpRequest<any>, handler: HttpHandler): Observable<HttpEvent<any>> {
    if (!request.url.includes(this.loginUrl)) {
      return handler.handle(request);
    }

    request = request.clone({
      setHeaders: {
        'x-canal': X_CHANNEL
      }
    });

    return handler.handle(request);
  }
}
